module.exports = __webpack_public_path__ + "img/Sharpsmart-LogoMedium.fcdff46b.png";